//=============================================================================
//                       <--- Developed By Icon Team ---> 02 february 2021
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import access from "config/access";

// custom pages
import { mpcDetailStyles } from "./styles";
import billtoConfiguration from 'apis/billtoConfiguration/billtoConfiguration';
import Context from "context/context";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
// material-ui icons
import ArrowBackOutlinedIcon from "@material-ui/icons/ArrowBackOutlined";
import { useTranslation } from 'react-i18next';
// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      "&.MuiOutlinedInput-root": {
        marginTop: 0,
        borderRadius: 20,
      },
    },
  },
})(TextField);

export default function BilltoConfigurationDetail(props) {
  const { state, dispatch } = useContext(Context);
  const { getAllAdminDetail, update } = billtoConfiguration();
  const history = useHistory();
  const location = useLocation();
  const classes = mpcDetailStyles();
  const [mpc, setMpc] = useState({});
  const [data, setData] = useState({});
  const [dataClone, setDataClone] = useState({});
  const [updated, setUpdated] = useState({});
  const [edit, setEdit] = useState(false);
  const [dataContract, setDataContract] = useState([]);

  
  const {t,i18n}=useTranslation()

  // setting mpc details
  // useEffect(() => {
  //   if (location.state && location.state.mpc) {
  //     setMpc(location.state.mpc);
  //     return;
  //   } else {
  //     history.goBack();
  //   }
  // }, []);

  // For bread-crumbs
  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "Billto Configuration"],
    });
  }, []);

  // handling api calls
  useEffect(() => {
    if (location?.state?.allAdminId) {
      handleGet();
      return;
    }
    history.goBack();
  }, []);

  // authorized members api func
  const handleGet = async () => {
    try {
      let id = location?.state?.allAdminId;
      let res = await getAllAdminDetail(id);
      if (res) {
        setData(res?.data);
        setDataClone(res?.data);
        setDataContract(res?.datacontract)
      }
    } catch (e) {
      console.log({ e });
    }
  };

  const handleUpdate = async () => {
    try {
      let arg = {};
      if(typeof updated?.system_managed =="boolean" ||typeof updated?.loyalty == "boolean"){
        console.log(data,updated)
        if(data?.system_managed != data?.loyalty){
          toast.error("System Managed and Loyalty should be same", {
            toastId: "update-btn",
          });
          return;
        }
        
      }
      arg = { updated, id: data?.id.toString() };
      let res = await update(arg);
      if (res) {
        setDataClone({ ...dataClone, ...res?.data });
        setEdit(false);
        history.push("/dashboard/upload-success", {
          type: "Data is updated to our system successfully.",
        });
      }
    } catch (e) {
      console.log({ e });
    }
  };

  let editObj = {
    // role_id: { edit: edit, type: "number" },
    system_managed: {
      edit: edit,
      type: "select",
      options: [
        { value: true, label: "Yes" },
        { value: false, label: "No" },
       
      ],
    },
    contract_code: {
      edit: edit,
      type: "select",
      options: dataContract,
    },
    loyalty: {
      edit: edit,
      type: "select",
      options: [
        { value: true, label: "Yes" },
        { value: false, label: "No" },
       
      ],
    },
    is_active: {
      edit: edit,
      type: "select",
      options: [
        { value: true, label: "Active" },
        { value: false, label: "Inactive" },
       
      ],
    },
  };

  let nameObj = {
    loyalty: "Loyalty",
    contract_code: "contract_code",
    is_active: "Status",
    customer_billto_account_number: "Billto",
    system_managed: "System_Managed",
    
  
  };

  let offset = location?.state?.offset;

  return (
    <React.Fragment>
      <Grid container style={{ padding: 10 }}>
        <Grid item xs={6}>
          <Button
            className={classes.editBtn}
            onClick={() => {
              history.push("/dashboard/billto-configuration", { offset });
            }}
          >
            {t('Back')}
          </Button>
        </Grid>
      </Grid>
            <Grid container>
        <div className={classes.firstDiv}>
          <div className={classes.secondDiv}>{t('Billto  Details')}</div>
        </div>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('Billto')}</span> :{" "}
            {data?.customer_billto_account_number}
          </div>
        </Grid>
        {/* <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('Role')}</span> :{" "}
            {data.HS_Role.role_name}
          </div>
        </Grid> */}
          <Grid xs={12} lg={6} className={classes.grid}>
       {editObj["contract_code"]?.edit ? (
            <Grid container>
              <Grid item xs={12}>
                <span style={{ fontWeight: "bold", verticalAlign: "Sub" }}>
                  {nameObj["contract_code"]}&nbsp;:&nbsp;
                </span>
                <CssTextField
                  variant="outlined"
                  select
                  fullWidth
                  className={classes.cssTextField}
                  value={data?.["contract_code"]}
                  onChange={(e) => {
                    setData({ ...data, ["contract_code"]: e.target.value });
                    setUpdated({ ...updated, ["contract_code"]: e.target.value });
                  }}
                >
                  {editObj["contract_code"]?.options.map((r, i) => (
                    <MenuItem value={r?.contract_code} key={i}>
                      {t(r?.contract_code)}
                    </MenuItem>
                  ))}
                </CssTextField>
              </Grid>
            </Grid> 
          ) : (
            <div>
            <span className={classes.gridSpan}>{t('Contract Code')}</span> :{" "}
            {data?.contract_code}
          </div>
        )}
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
       {editObj["system_managed"]?.edit ? (
            <Grid container>
              <Grid item xs={12}>
                <span style={{ fontWeight: "bold", verticalAlign: "Sub" }}>
                  {nameObj["system_managed"]}&nbsp;:&nbsp;
                </span>
                <CssTextField
                  variant="outlined"
                  select
                  fullWidth
                  className={classes.cssTextField}
                  value={data?.["system_managed"]}
                  onChange={(e) => {
                    setData({ ...data, ["system_managed"]: e.target.value });
                    setUpdated({ ...updated, ["system_managed"]: e.target.value });
                  }}
                >
                  {editObj["loyalty"]?.options.map((r, i) => (
                    <MenuItem value={r.value} key={i}>
                      {t(r.label)}
                    </MenuItem>
                  ))}
                </CssTextField>
              </Grid>
            </Grid> 
          ) : (
            <div>
            <span className={classes.gridSpan}>{t('System Managed')} </span> :{" "}
            {typeof data?.["system_managed"] == "boolean" ? (
              data?.["system_managed"] ? (
                <span className={classes.activeSpan}>{t('Yes')}</span>
              ) : (
                <span className={classes.inActiveSpan}>{t('No')}</span>
              )
            ) : (
              data["system_managed"]
            )}
          </div>
        )}
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
       {editObj["loyalty"]?.edit ? (
            <Grid container>
              <Grid item xs={12}>
                <span style={{ fontWeight: "bold", verticalAlign: "Sub" }}>
                  {nameObj["loyalty"]}&nbsp;:&nbsp;
                </span>
                <CssTextField
                  variant="outlined"
                  select
                  fullWidth
                  className={classes.cssTextField}
                  value={data?.["loyalty"]}
                  onChange={(e) => {
                    setData({ ...data, ["loyalty"]: e.target.value });
                    setUpdated({ ...updated, ["loyalty"]: e.target.value });
                  }}
                >
                  {editObj["loyalty"]?.options.map((r, i) => (
                    <MenuItem value={r.value} key={i}>
                      {t(r.label)}
                    </MenuItem>
                  ))}
                </CssTextField>
              </Grid>
            </Grid> 
          ) : (
            <div>
            <span className={classes.gridSpan}>{t('Loyalty')} </span> :{" "}
            {typeof data?.["loyalty"] == "boolean" ? (
              data?.["loyalty"] ? (
                <span className={classes.activeSpan}>{t('Yes')}</span>
              ) : (
                <span className={classes.inActiveSpan}>{t('No')}</span>
              )
            ) : (
              data["loyalty"]
            )}
          </div>
        )}
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
       {editObj["is_active"]?.edit ? (
            <Grid container>
              <Grid item xs={12}>
                <span style={{ fontWeight: "bold", verticalAlign: "Sub" }}>
                  {nameObj["is_active"]}&nbsp;:&nbsp;
                </span>
                <CssTextField
                  variant="outlined"
                  select
                  fullWidth
                  className={classes.cssTextField}
                  value={data?.["is_active"]}
                  onChange={(e) => {
                    setData({ ...data, ["is_active"]: e.target.value });
                    setUpdated({ ...updated, ["is_active"]: e.target.value });
                  }}
                >
                  {editObj["is_active"]?.options.map((r, i) => (
                    <MenuItem value={r.value} key={i}>
                      {t(r.label)}
                    </MenuItem>
                  ))}
                </CssTextField>
              </Grid>
            </Grid> 
          ) : (
            <div>
              <span className={classes.gridSpan}>{t('Status')} </span> :{" "}
              {typeof data?.["is_active"] == "boolean" ? (
                data?.["is_active"] ? (
                  <span className={classes.activeSpan}>{t('Active')}</span>
                ) : (
                  <span className={classes.inActiveSpan}>{t('Inactive')}</span>
                )
              ) : (
                data["is_active"]
              )}
            </div>
        )}
        </Grid>
        <Grid item xs={12} lg={2} className={classes.gridBtn}>
          <Grid item xs={12} lg={6}>
            {edit && (
              <Button
                className={classes.editCancelBtn}
                onClick={() => {
                  setData(dataClone);
                  setEdit(false);
                }}
              >
                {t('cancel')}
              </Button>
            )}
          </Grid>
          <Grid item xs={12} lg={6}>
            <Button
              className={classes.editBtn}
              onClick={()=>{
                if(state?.userInfo?.editAction){
                if (edit) {
                  if (Object.keys(updated).length > 0) {
                    handleUpdate();
                    return;
                  }
                
                  toast.error("Edit atleast one field.", {
                    toastId: "update-btn",
                  });
                } else {
                  setEdit(true);
                }
                return;
              }
            else{
              toast.error(state.userInfo?.editAccess)
            return;
          }}}
              // disabled={!access['editAccess'][state.userInfo?.role]['mpcdetail']}
            >
              {edit ? "Update" : "Edit"}
            </Button>
          </Grid>
        </Grid>
      </Grid>
      

      <Grid container>
       {/* <Grid item xs={12} lg={2} className={classes.gridBtn}>
          <Grid item xs={12} lg={6}>
            {edit && (
              <Button
                className={classes.editCancelBtn}
                onClick={() => {
                  setData(dataClone);
                  setEdit(false);
                }}
              >
                {t('cancel')}
              </Button>
            )}
          </Grid>
          <Grid item xs={12} lg={6}>
            <Button
              className={classes.editBtn}
              onClick={()=>{
                if(access['editAccess'][state.userInfo?.role]['mpcdetail']){
                if (edit) {
                  if (Object.keys(updated).length > 0) {
                    handleUpdate();
                    return;
                  }
                  toast.error("Edit atleast one field.", {
                    toastId: "update-btn",
                  });
                } else {
                  setEdit(true);
                }
                return;
              }
            else{
              toast.error(state.userInfo?.editAccess)
            return;
          }}}
              // disabled={!access['editAccess'][state.userInfo?.role]['mpcdetail']}
            >
              {edit ? "Update" : "Edit"}
            </Button>
          </Grid>
        </Grid> */}
        {/* <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('Org name')}</span> :{" "}
            {t(data.loyalty_organization_name)}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('Site name')}</span> :{" "}
            {t(data.loyalty_site_id)}
          </div>
        </Grid> */}
      </Grid>
    </React.Fragment>
  );
}
